import {BasicEntity} from '../../framework/message/BasicEntity';
import {Profile} from './Profile';
import {Role} from './Role';

export class UserApplication extends BasicEntity {
doNone: boolean | null;
main: boolean | null;
ownerId: number | null;
perimeter: string;
profiles: Profile[];
roles: Role[];
tags: Object;
userType: string;
visionCode: string;
}

